import { useEffect, useRef, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TwitterPublishingProvider from '../../../services/socialpublishing/TwitterPublishingProvider';
import Loading from './Loading';
import { EventBus } from '../../../helpers/EventBus';
import { ShareTo } from '../../../config/Enums';

// Publishing authorisation is separate from the Accounts sign-in identity.
export default function TwitterCallback() {
  const started = useRef(false);
  const [error, setError] = useState('');
  const [finished, setFinished] = useState(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    if (!TwitterPublishingProvider.isAwaitingPublishingCallback()) {
      setError('This sign-in link is no longer supported. Sign in through Accounts.');
      return;
    }
    void new TwitterPublishingProvider().handleCallback().then(() => setFinished(true)).catch(() => {
      setError('Unable to connect X for publishing. Please retry from CMS.');
      if (window.opener) {
        window.opener.postMessage({ event: EventBus.Event.OnSocialMediaPublishingConnected, type: ShareTo.X, success: false }, '*');
        window.close();
      }
    });
  }, []);
  if (error) return <Alert variant="warning" className="m-4">{error} <Link to="/signin">Open CMS</Link></Alert>;
  return finished ? <Alert variant="info" className="m-4">Return to CMS to view the publishing connection result.</Alert>
    : <Loading Message="Connecting X for publishing..." SpinSize="5x" />;
}
